import { useQuery } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { appointmentApi } from "../service";

export function useAppointmentsByWorkOrder(workOrderId?: string | null) {
  return useQuery({
    queryKey: appointmentKeys.byWorkOrder(workOrderId ?? ""),
    queryFn: () => appointmentApi.getByWorkOrderId(workOrderId!).then((r) => r.data),
    enabled: Boolean(workOrderId),
  });
}
